// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"649":"476a7a56","654":"276853ec"}[chunkId] + ".chunk.css";
};